<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40"  lazy transition="scale-transition" offset-y full-width min-width="290px">
          <template v-slot:activator="{on}">
            <v-text-field v-model="formattedDate" prepend-icon="event" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title @input="setDate()" :first-day-of-week="0" locale="jp-ja" :day-format="date => new Date(date).getDate()">
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex md2>
        <v-select :items="hours" v-model="hour" label="時" />
      </v-flex>
      <v-flex md2>
        <v-select :items="minutes" v-model="min" label="分" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { moment, unixtimeToFormattedDate, FormattedDateTounixtime, unixtimeToFormattedDatetime, unixtimeToDate } from "@/utils/datetime.js"


export default {
  data: () => ({
    hours: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
    minutes: [0, 10, 20, 30, 40, 50],
    menu: false,
    date:""
  }),
  props: {
    value: {
      default: 0,
      type: Number,
    }

  },
  mounted() {
  },
  watch:{
    value(){
      this.date = unixtimeToFormattedDate(this.value)
    }
  },
  computed: {

    hour: {
      get() {
        return moment.unix(this.value).hour()
      },
      set(hour) {
        const m = moment.unix(this.value)
        m.hour(hour)
        this.$emit('input', m.unix())
      }
    },
    min: {
      get() {
        return moment.unix(this.value).minute()
      },
      set(min) {
        const m = moment.unix(this.value)
        m.minute(min)
        this.$emit('input', m.unix())
      }
    },
    formattedDate: {
      get() {
        return unixtimeToFormattedDate(this.value)
      },
      set(formattedDate) {
        const m = moment(formattedDate).hour(this.hour).minute(this.minutes)
        this.$emit('input', m.unix())
      }
    },
  },
  methods: {
    setDate() {
      this.formattedDate = this.date
      this.menu = false
    }
  }
}
</script>

